import { TStoreApi, TContainerProps, IStory } from '../common/types';
const OK_RESPONSE = 'ok';

const setLoading = (status: boolean) => ({ setState }: TStoreApi): void => {
  setState((draft) => {
    draft.loading = status;
  });
};

export const actions = {
  // https://api-docs.unfold.com/#/Story/get_story
  load: () => async (
    { setState, dispatch }: TStoreApi,
    { api }: TContainerProps
  ): Promise<void> => {
    dispatch(setLoading(true));

    const { data } = await api.get('/api/v1/story');
    setState((draft) => {
      draft.stories = data;
    });

    dispatch(setLoading(false));
  },

  // https://api-docs.unfold.com/#/Story/delete_story__ID_
  deleteStory: (id: string) => async (
    { setState, dispatch }: TStoreApi,
    { api }: TContainerProps,
  ): Promise<void> => {
    dispatch(setLoading(true));
    const { data: response } = await api.delete(`/api/v1/story/${id}`);
    if (response.msg === OK_RESPONSE) {
      setState((draft) => {
        draft.stories = draft.stories.filter(story => story.uuid !== id);
      });
    }
    dispatch(setLoading(false));
  },

  // https://api-docs.unfold.com/#/Story/patch_story__ID_
  updateStory: (storyId: string, data: Partial<IStory>) => async (
    { setState, }: TStoreApi,
    { api }: TContainerProps
  ): Promise<void> => {
    // dispatch(setLoading(true));
    await api.patch(`/api/v1/story/${storyId}`, data);
    setState(draft => {
      draft.stories = draft.stories.map((story) => {
        if (story.uuid === storyId) {
          return {
            ...story,
            ...data
          };
        }
        return story;
      })
    });
    // dispatch(setLoading(false));
  },
  // duplicateStory: (id: string) => async (
  //   { setState, dispatch }: TStoreApi,
  //   { api }: TContainerProps,
  // ): Promise<void> => {
  //   const { data: response } = await api.post('/api/v1/story/');
  // },

  // // https://api-docs.unfold.com/#/Story/put_story_get_storage_link__uuid_
  // updateStoryLink: (data) => async (
  //   { setState, dispatch }: TStoreApi,
  //   { api }: TContainerProps
  // ): Promise<void> => {
  //   const { data: response } = await api.put(`/api/v1/story/get-storage-link/${data.uuid}`, data);
  // },

  // // https://api-docs.unfold.com/#/Story/patch_story__ID_
  // updateStory: (data) => async (
  //   { setState, dispatch }: TStoreApi,
  //   { api }: TContainerProps
  // ): Promise<void> => {
  //   const { data: response } = await api.patch(`/api/v1/story/get-storage-link/${data.id}`, data);
  // },
};

export type TActions = typeof actions;
